/* eslint-disable no-empty-pattern */
import { queryString } from '@utils/format';
import http from '@plugins/axios';

export const actions = {
  async fetch({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    return await http.get(`/psp/i/${id}/pendampingan-pa`, { params: payload.params }).then(({ data }) => data);
  },

  async getDetail({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    return await http.get(`/psp/i/${id}/pendampingan-pa/${payload.id}`).then(({ data }) => data);
  },

  update({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    const url = `/psp/i/${id}/pendampingan-pa/${payload.id}/update`;
    return http.post(url, payload.params).then(({ data }) => data);
  },

  action({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    const url = `/psp/i/${id}/pendampingan-pa/${payload.id}/${payload.type}`;
    return http.post(url, payload.params).then(({ data }) => data);
  },

  downloadList({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    const url = `${process.env.VUE_APP_API_URL}/psp/i/${id}/kp-pa/${payload.url}?${queryString(payload.params)}`;
    return Promise.resolve(url);
  },
};
